import { useState } from 'react';

export interface DeleteModalState {
  isOpen: boolean;
  entityType: 'field' | 'deposit' | 'section' | 'horizon' | 'bed' | null;
  entityData: any | null;
  parentIds: {
    fieldUuid?: string;
    depositUuid?: string;
    areaUuid?: string;
    horizonUuid?: string;
  } | null;
  error: string | null;
}

export const useDeleteModal = () => {
  const [deleteModal, setDeleteModal] = useState<DeleteModalState>({
    isOpen: false,
    entityType: null,
    entityData: null,
    parentIds: null,
    error: null
  });

  const openDeleteModal = (
    entityType: DeleteModalState['entityType'],
    entityData: any,
    parentIds?: DeleteModalState['parentIds']
  ) => {
    setDeleteModal({
      isOpen: true,
      entityType,
      entityData,
      parentIds: parentIds || null,
      error: null
    });
  };

  const closeDeleteModal = () => {
    setDeleteModal({
      isOpen: false,
      entityType: null,
      entityData: null,
      parentIds: null,
      error: null
    });
  };

  const setDeleteError = (error: string) => {
    setDeleteModal(prev => ({
      ...prev,
      error
    }));
  };

  return {
    deleteModal,
    openDeleteModal,
    closeDeleteModal,
    setDeleteError
  };
};